// extracted by mini-css-extract-plugin
export default {"fileGuideOptionButton":"file-guide-option-button_fileGuideOptionButton__I1aRP","fileGuideOptionButtonActive":"file-guide-option-button_fileGuideOptionButtonActive__ieSwk"};